
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Musical Tribute</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm raagas-urvashi section-banner-bg-1">
    <div class="container">
        <div class="row justify-content-center align-items-center">

            <div class="sec-title text-center">
                <h2>Forever Lata : A Musical Tribute to <span > -
                        Bharat Ratna Lata Mangeshkar Akola</span></h2>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <p class="text-justify">G. H Raisoni Sports and Cultural Foundation organizes ‘Forever Lata’ - A
                        Musical Tribute to Lata Mangeshkar ji. The event is powered by the Raisoni Group of Institutions
                        and supported by G H Raisoni University, and SGR Knowledge Foundation. ‘Forever Lata’ is a
                        heartfelt tribute that aims to celebrate the exceptional music of the legendary singer Lata
                        Mangeshkar. The grand event features a group of highly talented and well-known artists from
                        Nagpur’s musical group ‘Sur Sangam’, who performs Lata Mangeshkar's timeless songs, recalling
                        her immense contribution to Indian cinema. </p>
                    <p class="text-justify">Earlier GHRSCF had organized the event in Nagpur, Chandrapur, Wardha and
                        extended to other different cities across Maharashtra. The event’s success usually depends on
                        the testament to the passion and commitment of the organizer G H Raisoni Sports and Cultural
                        Foundation fits in and celebrates India’s rich cultural heritage by organizing such events for
                        the general public, free of charge. The Initiative is supported and encouraged by Shri Sunil
                        Raisoni, Chairman, Raisoni Group of Institutions, He has been a driving force behind the event,
                        and has made this initiative possible.</p>
                    <p class="text-justify">All the music enthusiasts, cinephiles, and the general public are invited to
                        join the upcoming event. For more details and registration visit the following link
                        <!-- <a href="https://www.ghrscf.com/cultural-events">Link:-https://www.ghrscf.com/cultural-events</a> -->
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-8">

                    <p><strong>Let’s meet you then.</strong></p>

                    <p><b>Topic: A Musical Tribute to Bharat Ratna - Lata Mangeshka </b></p>
                    <p><b>Date – Sunday, 9<sup>th</sup> July 2023 </b></p>
                    <p><b>Time – 05:00 pm - Sharp (Grab your seats before time)</b></p>
                    <p><b>Venue: Pramilatai Oak Hall, New Radhakrishna Plot, Shastri Nagar, Akola, Maharashtra
                            444001</b></p>
                </div>
                <div class="col-md-4">
                    <div class="image-effect-2">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/lata-mangeshkar_akola.jpg"
                            alt="GHRSCF" style="width: 100%;">
                    </div>
                </div>
            </div>
        </div>
        <div class="border-line-sm"></div>
    </div>
</section>
